import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getUserDefaultSettings } from "entities/helpers/thankview-helper";
import useUserAuthentication from "./useUserAuthentication";

const ThankviewSettingsContext = createContext();

export const ThankviewSettingsProvider = ({ children }) => {
  const [defaultUserSettings, setDefaultUserSettings] = useState({});
  const { clientId = "" } = useUserAuthentication();
  const [loadingDefaultSettings, setLoading] = useState(true);

  useEffect(() => {
    const getAndSetUserSettings = async () => {
      if (clientId) {
        setLoading(true);
        const { data } = await getUserDefaultSettings(clientId.data.client_id, clientId.data.client_secret);
        setDefaultUserSettings(data);
      }
      setLoading(false);
    };
    getAndSetUserSettings();
  }, [clientId]);

  return (
    <ThankviewSettingsContext.Provider value={{ defaultUserSettings, loadingDefaultSettings }}>
      {children}
    </ThankviewSettingsContext.Provider>
  );
};

export const useThankviewSettingsContext = () => useContext(ThankviewSettingsContext);

ThankviewSettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
